/**
 * Increment text per interval
 * @param text {String}
 * @param setText {function(String): void}
 * @param interval {Number}
 * @param complete {function(): void}
 */
export const increment = ({text, setText, interval = 350, complete = null}) => {
    const parts = text.split('');
    const steps = []

    for (let i = 0; i <= parts.length; i++) {
        steps.push(function () {
            setText(parts.slice(0, i).join(''))
            setTimeout(steps[i + 1], interval)
        })
    }

    steps.push(complete || function () {
        // do nothing
    })

    steps[0]()
}

/**
 * Increment text per interval
 * @param text {String}
 * @param setText {function(String): void}
 * @param interval {Number?}
 * @param complete {function(): void?}
 */
export const decrement = ({text, setText, interval = 150, complete = null}) => {
    const parts = text.split('');
    const steps = []

    for (let i = 0; i <= parts.length; i++) {
        steps.push(function () {
            setText(parts.slice(i, parts.length).join('') || '')
            setTimeout(steps[i + 1], interval)
        })
    }

    steps.push(complete || function () {
        // do nothing
    })

    steps[0]()
}

